import { Moon, Sun } from 'lucide-react';
import { Button } from './ui/button';

export const ThemeToggle = ({ theme, onToggle }) => (
  <Button variant="ghost" size="icon" className="theme-toggle" onClick={onToggle} aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'} aria-pressed={theme === 'dark'} data-theme-state={theme} data-testid="theme-toggle">
    {theme === 'dark' ? <Sun size={17} strokeWidth={1.5} aria-hidden="true" /> : <Moon size={17} strokeWidth={1.5} aria-hidden="true" />}
  </Button>
);
